Element.prototype.validateForm = function () {
    if (this.tagName !== 'FORM') return false;
    let formIsValid = true;
    this.querySelectorAll('.validate').forEach(input => {
        if (input.offsetParent === null) return;
        let type = input.dataset.validate;
        let value = input.value;
        let valid = inputValidationFunctions[type](value, input);

        if (!valid) {
            formIsValid = false;
            input.addClass('invalid');
            ['focus', 'input'].forEach(event => {
                input.addEventListener(event, unmarkInvalidInput);
            })
        }
    })
    return formIsValid;
};

function unmarkInvalidInput() {
    this.removeClass('invalid');
    ['focus', 'input'].forEach(event => {
        this.removeEventListener(event, unmarkInvalidInput);
    })
}

Element.prototype.unmarkInvalid = function () {
    if (this.tagName !== 'FORM') return false;
    this.querySelectorAll('.validate.invalid').forEach(input => {
        ['focus', 'input'].forEach(event => {
            input.removeClass('invalid');
            input.removeEventListener(event, unmarkInvalidInput);
        })
    });
}

const inputValidationFunctions = {
    text: (value, input) => {
        value = value.trim();
        let valid = true;
        if ('min' in input.dataset) if (value.length < input.dataset.min) valid = false;
        if ('max' in input.dataset) if (value.length > input.dataset.max) valid = false;
        return valid;
    },
    email: value => {
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(value.trim());
    }
}